<template src="@/templates/reservations/component-view.html"></template>


<script>
import entityStore from '@/store/entityStore';

export default {
  props: [
    'component',
  ],
  computed: {
    iconClass() {
      // check if component is set
      if (this.component) {
        return {
          fa: true,
          'fa-plane': this.component.type === 'flight',
          'fa-bed': this.component.type === 'hotel',
          'fa-ship': this.component.type === 'ship',
          'fa-bus': this.component.type === 'pickUp',
          '': this.component.type === 'activity',
          'fa-cube': this.component.type === 'arrangement',
        };
      }
      return {};
    },
  },
  methods: {
    formatName(passenger) {
      if (entityStore.state.name === 'amigo') {
        return `${passenger.salutation} ${passenger.initials} ${passenger.middlename} ${passenger.lastname}`;
      }
      return `${passenger.salutation} ${passenger.initials} ${entityStore.formatPassengerName(passenger)}`;
    },
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// component-view.vue?228de65e